module.exports = __webpack_public_path__ + "static/media/White_Globe.847e167e.png";